class SelectCorner {
  select: NodeListOf<Element> | null;
  constructor() {
    this.select = document.querySelectorAll('select[data-trigger="select-corner"]');
    
    if (this.select) {
      this._init();
    }
  }
  
  _init() {
    this.select!.forEach(element => {
      element.addEventListener('change', (e: Event) => {
        console.log("TEST");
        if(e?.target){
          this.changeSelect(e?.target);
        }
      });
    });
  }

  changeSelect(element: EventTarget): void {
    this.select = document.querySelectorAll('select[data-trigger="select-corner"]');
    let url = document.location.origin + '/' + document.location.pathname.split('/')[1];
    console.log(url);
    this.select!.forEach((item: Element, index) => {
      const category = item.getAttribute("data-target");
      const value = (<HTMLSelectElement>item).value;
      if(index > 0){
        url +=  `&${category}=${encodeURIComponent(value)}`;
      }else{
        url +=  `?${category}=${encodeURIComponent(value)}`;
      }
    });
    
    window.location.href = url;
  }
}

export let selectCorner = new SelectCorner();
